import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { CustomBarChartComponent } from '../../shared/components/custom-bar-chart/custom-bar-chart.component';
import { PrintFilterDataComponent } from '../../shared/components/print-filter-data/print-filter-data.component';
import { ChartTypeColorsEnum } from '../../utils/enums/chart-colors.enum';
import { IReportFilter } from '../../utils/interfaces/report-filter';
import { ISummaryReport } from '../../utils/interfaces/summary-report';

@Component({
  selector: 'app-summary-report-body',
  standalone: true,
  imports: [CommonModule, PrintFilterDataComponent, CustomBarChartComponent],
  templateUrl: '../../main/report/report-data/summary/summary.component.html',
  styleUrl: '../../main/report/report-data/summary/summary.component.scss',
  styles: [
    `
      :host {
        display: block;
      }

      @media print {
        :host .count,
        :host .satisfacao,
        :host .img-description,
        :host .values,
        :host img,
        :host ::ng-deep app-custom-bar-chart .content-bar,
        :host ::ng-deep app-custom-bar-chart .img-description,
        :host ::ng-deep app-custom-bar-chart .values,
        :host ::ng-deep app-custom-bar-chart img {
          break-inside: avoid;
          page-break-inside: avoid;
        }

        :host .title,
        :host .count,
        :host .satisfacao,
        :host ::ng-deep app-custom-bar-chart .img-description,
        :host ::ng-deep app-custom-bar-chart .values {
          break-after: avoid;
          page-break-after: avoid;
        }
      }
    `,
  ],
})
export class SummaryReportBodyComponent {
  @Input() print = false;
  @Input() filter: IReportFilter | null = null;
  @Input() data: ISummaryReport | null = null;
  chartColorsEnum = ChartTypeColorsEnum;
}
